import HeaderSearchBar from 'containers/HeaderSearchBar/HeaderSearchBar'
import React from 'react'
import { useApolloClient } from "@apollo/client/react";
import querySearchAll from 'graphql/queries/querySearchAll'
import { searchAll, searchAllVariables } from 'graphql/queries/types/searchAll'
import { getLocalStorageToken } from 'store/localStorage'
import SearchResults from 'components/SearchResults/SearchResults'
import { SidebarMenuContext } from 'providers/SidebarMenuProvider'
import { HeaderSearchContext } from 'providers/HeaderSearchProvider'
import { useNavigate } from 'react-router'

export interface Props {
  style?: React.CSSProperties
}

const SearchBarContainer: React.FC<Props> = ({ style }) => {
  const client = useApolloClient()
  const navigate = useNavigate()

  return (
    <div style={{ ...style }}>
      <SidebarMenuContext.Consumer>
        {(p) => {
          const { actions } = p ?? {}
          const { closeMenu } = actions ?? {}
          return (
            <HeaderSearchContext.Consumer>
              {(p) => {
                const { searchPhrase, actions } = p ?? {}
                const {
                  focusSearch = () => {},
                  setData,
                  clearSearchResult = () => {},
                  setLoading,
                  setSearchPhrase,
                } = actions ?? {}
                const goToLink = (url: string) => {
                  navigate(url)
                  setSearchPhrase?.('')
                  closeMenu?.()
                }
                return (
                  <HeaderSearchBar
                    onCancel={clearSearchResult}
                    onSearch={async () => {
                      setLoading?.(true)
                      try {
                        const { data } = await client.query<searchAll, searchAllVariables>({
                          query: querySearchAll,
                          variables: { token: getLocalStorageToken(), searchPhrase: searchPhrase ?? '' },
                        })
                        const terminals = data?.viewer?.terminals ?? []
                        const persons = data?.viewer?.ipPersons ?? []
                        setData?.(terminals, persons)
                        setLoading?.(false)
                      } catch (err) {
                        setLoading?.(false)
                      }
                    }}
                    onFocus={focusSearch}
                    goToLink={goToLink}
                  >
                    <SearchResults goToLink={goToLink} />
                  </HeaderSearchBar>
                )
              }}
            </HeaderSearchContext.Consumer>
          )
        }}
      </SidebarMenuContext.Consumer>
    </div>
  )
}

export default SearchBarContainer
